import React from "react";
import OverallProgressForm from "../OverallProgressForm";

const OverallProgress = (props) => (
  <OverallProgressForm
    apiBase="micro-grants"
    statusLabel="Status of Overall Grant"
    {...props}
  />
);

export default OverallProgress;
